<template>
  <div
    class="animate__bounceIn animate__animated voice-call"
  >
    <div class="text-center">
      <video id="remote-video" />
      <video id="local-video" playsinline :class="{'hide-video': !voiceCall.video}" />
    </div>

    <div class="time-rune">
      {{ time | convertHMS }}
    </div>
    <button class="button button-accept" @click="closeStream()">
      <i class="fas fa-phone" />
    </button>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import * as Sentry from '@sentry/vue'
import config from '@/config'
import utils from '@/util'

export default {
  components: {
  },
  data() {
    return {
      remoteVideos: [],
      localVideo: null,
      time: 0,
      runTime: null,
    }
  },
  computed: {
    ...mapState({
      voiceCall: (state) => state.voiceCall,
      presentation: (state) => state.presentation,
      audienceId: (state) => state.audienceId,
    }),
    ...mapGetters({
      slide: 'activeActivity',
    }),
  },
  mounted() {
    this._initOpenTokSession()
    this.runTime = setInterval(() => {
      this.time++
    }, 1000)
  },
  destroyed() {
    if (this.runTime) {
      clearInterval(this.runTime)
      this.runTime = null
    }
  },
  methods: {
    async _initOpenTokSession() {
      this.session = window.OT.initSession(config.openTokKey, this.presentation.session)
      const self = this
      // Subscribe to a newly created stream

      // Create a publisher

      // eslint-disable-next-line
      const publisher = window.OT.initPublisher('publisher', { insertDefaultUI: false, name: this.audienceId, publishVideo: this.voiceCall.video }, (error) => {
        if (error) return self.handleError

        const event = {
          id: self.audienceId,
          stream: publisher._.webRtcStream(),
          type: 'local',
        }
        self.localVideo = event
        const localVideo = document.getElementById('local-video')
        localVideo.volume = 0
        try {
          localVideo.setAttributeNode(document.createAttribute('muted'))
        } catch (e) {
          Sentry.captureException(e)
          localVideo.setAttribute('muted', true)
        }
        localVideo.srcObject = publisher._.webRtcStream()
        localVideo.play()
      })

      // Connect to the session
      self.session.connect(self.presentation.token, (error) => {
        // If the connection is successful, publish to the session
        if (error) {
          self.handleError(error)
        } else {
          self.session.publish(publisher, self.handleError)
        }
      })

      self.session.on('streamCreated', (event) => {
        // eslint-disable-next-line consistent-return
        const subscriber = self.session.subscribe(event.stream, { insertDefaultUI: false }, (error) => {
          if (error) return self.handleError
          const eventRemote = {
            id: subscriber.stream.name,
            stream: subscriber._.webRtcStream(),
            type: 'remote',
          }
          self.remoteVideo = eventRemote
          const remoteVideo = document.getElementById('remote-video')
          remoteVideo.srcObject = subscriber._.webRtcStream()
          remoteVideo.play()
          utils.mixpanelTrack('Video Call', 'Audience Connected Call', `Video: ${self.voiceCall.video}`)
        })
      })

      self.session.on('streamDestroyed', () => {
        self.closeStream()
      })
    },
    _stopStreamedVideo(stream) {
      const tracks = stream.getTracks()
      tracks.forEach((track) => {
        track.stop()
      })
    },
    closeStream() {
      if (this.remoteVideo) {
        this._stopStreamedVideo(this.remoteVideo.stream)
      }
      if (this.localVideo) {
        this._stopStreamedVideo(this.localVideo.stream)
      }
      if (this.session) {
        this.session.off('streamCreated')
        this.session.off('streamDestroyed')
        setTimeout(() => {
          this.session.disconnect()
          this.session = null
        }, 1000)
      }
      this.$store.state.voiceCall = {}
      const slideName = utils.getCorrectSlideTypeName(this.slide)
      utils.mixpanelTrack('Video Call', 'Audience Close Call', slideName)
    },
    handleError() {
      // do nothing
    },
  },
}
</script>

<style lang="scss" scoped>
.voice-call {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000000bf;
  z-index: 1000;
  color: #fff;
  padding: 8px;
}
.close-call {
  font-weight: bold;
  font-size: 18px;
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
}

#local-video {
  width: 100%;
  height: auto;
  max-width: 400px;
  margin: 0 auto;
  &.hide-video {
    visibility: hidden;
  }
}
#remote-video {
  position: fixed;
  left: -9999px;
  width: 10px;
  height: 10px;
}
#play-call {
  position: fixed;
  width: 10px;
  height: 10px;
  left: -9999px;
}

button.button-accept {
  background: #DA323C;
  border: 1px solid #F4F4F4;
  border-radius: 55px;
  width: 60px;
  font-size: 24px;
  height: 60px;
  display: block;
  margin: 16px auto;
  text-align: center;

  i {
    transform: rotate(-135deg);
  }
}
.time-rune {
  text-align: center;
  margin: 16px auto;
}
</style>
